document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-faq-tabs]");

  sections.forEach((section) => {
    const tabTriggers = section.querySelectorAll("[data-tab-trigger]");
    const tabPanels = section.querySelectorAll("[data-tab-panel]");

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const target = trigger.getAttribute("data-tab-target");

        tabTriggers.forEach((item) => {
          item.classList.remove("is-active");
          item.setAttribute("aria-selected", "false");
        });

        tabPanels.forEach((panel) => {
          panel.classList.remove("is-active");
        });

        trigger.classList.add("is-active");
        trigger.setAttribute("aria-selected", "true");

        const activePanel = section.querySelector(`[data-tab-panel-id="${target}"]`);
        if (activePanel) {
          activePanel.classList.add("is-active");
        }
      });
    });
  });
});